<template>
  <div :id="`${source}_call_forwarding_toggle`" class="px-2">
    <a-switch size="small" :checked="isEnabled" @change="handleSwitchChange" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import CallService from "@/src/api/CallService.js";
import { message } from "ant-design-vue";
import eventBus from "@/src/utils/eventBus.js";

const props = defineProps({
  source: { type: String, required: true, default: "custom_table" },
  row: { type: Object, required: true },
});

const isEnabled = ref(props.row?.is_forwarding_enabled === true);

const handleSwitchChange = async (checked) => {
  try {
    if (props.row?.forwarding_number === "" && checked) {
      eventBus.emit("forwarding-toggle", props.row);
      return;
    }

    isEnabled.value = checked;

    const payload = {
      is_enabled: checked,
    };

    const response = await CallService.updateForwardingNumber(
      props.row?.id,
      payload,
    );

    if (response?.success) {
      message.success(
        `Call Forwarding ${checked ? "enabled" : "disabled"} for ${props.row?.phone_number}`,
      );
    }
  } catch (error) {
    isEnabled.value = !checked;
    console.error(
      "An error occurred while updating forwarding number: ",
      error,
    );
    message.error(error?.response?.data?.error || "An error occurred while updating forwarding number");
  }
};
</script>
